import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()
export class LayoutPrintFormService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getLayoutPrint(id: string) {
        const url = this.apiUrl + 'api/cms/layout-print/get/'+id;
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');

        return this.http.get(url, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    createLayoutPrint(data: any) {
        const url = this.apiUrl + 'api/cms/layout-print/create';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        
        return this.http.post(url, body,{ headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    editLayoutPrint(data: any) {
        const url = this.apiUrl + 'api/cms/layout-print/edit';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        
        return this.http.put(url, body,{ headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print-form/layout-print-form.service.ts